export default function replaceLocation(url: string) {
  if (typeof window !== 'undefined') {
    window.location.href = url
  }
}
